//#region Libraries
import { useState } from "react";
import { useEffect } from "react";
//#endregion
//#region Styles
import { 
    ButtonLink,
    Column,
    TitleSection } from "components/styles";
import { 
    Container, 
    ListTime } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";
import ListTimeItem from "./ListTimeItem";
import CloseButton from "components/CloseButton/CloseButton";
//#endregion
//#region Services
//#endregion

const errorInactivityTime = {
    time: {
        start: false,
        end: false,
        areInvalidTimes: false
    },
    date: false
};

const InactivityDialog = ({
    show,
    toggleShow,
    inactivity = [],
    verifyAreInvalidTimes,
    changeInactivity,
    ratioMinutesTime,
    errors,
    intervalTimePicker,
    date, availableDay
}) => {
    //#region States
    const [prevInactivity, setPrevInactivity] = useState({ 
        values: [],
        errors: []
    });
    const [currentIdxInactivityItemToDelete, setCurrentIdxInactivityItemToDelete] = useState(-1);
    const [showDialogSaveInactivity, setShowDialogSaveInactivity] = useState(false);
    const [showDialogDeleteInactivity, setShowDialogDeleteInactivity] = useState({
        question: false,
        success: false
    });
    const [showDialogCancelInactivityUpdating, setShowDialogCancelInactivityUpdating] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!show) 
            return;
        setPrevInactivity({
            values: [...inactivity],
            errors: [...errors]
        });
    }, [show]);
    //#endregion
    //#region Functions
    //#region Dialogs
    const toggleShowDialogSaveInactivity = (value = null) => {
        setShowDialogSaveInactivity(value === null ? !showDialogSaveInactivity : value);
    }
    const toggleShowDialogCancelInactivityUpdating = (value = null) => {
        setShowDialogCancelInactivityUpdating(value === null ? !showDialogCancelInactivityUpdating : value);
    }
    const toggleShowDialogDeleteInactivity = (field, value = null) => {
        setShowDialogDeleteInactivity({
            ...showDialogDeleteInactivity,
            [field]: value === null ? !showDialogDeleteInactivity[field] : value
        });
    }
    const closeDialogDeleteInactivityQuestion = () => toggleShowDialogDeleteInactivity("question", false);
    const openDialogDeleteInactivityQuestion = idx => {
        toggleShowDialogDeleteInactivity("question", true);
        setCurrentIdxInactivityItemToDelete(idx);
    };
    const someInactivityItemWasModified = () => {
        return inactivity.some(({ wasModified }) => wasModified)
    }
    const closeDialog = (closeAtAnyRate = false) => {
        if (!closeAtAnyRate && someInactivityItemWasModified()) {
            setShowDialogCancelInactivityUpdating(true);
            return;
        }
        toggleShow(false);
        setShowDialogCancelInactivityUpdating(false);
        setTimeout(() => {
            changeInactivity(prevInactivity.values, prevInactivity.errors);
        }, 400);
    }
    //#endregion
    //#region Actions
    const addInactivityTime = () => {
        const newInactivity = [...inactivity, {
            time: {
                start: -1,
                end: -1,
            },
            date: -1,
            wasModified: false
        }];
        const newErrorsInactivity = [
            ...errors,
            { ...errorInactivityTime }
        ];
        changeInactivity(newInactivity, newErrorsInactivity);
        setPrevInactivity({
            values: [...newInactivity],
            errors: [...newErrorsInactivity]
        });
    }
    const getNewInactivityTime = (idx, field, value, wasModified) => {
        const copyInactivity = [...inactivity];        
        copyInactivity[idx] = {
            ...copyInactivity[idx],
            time: {
                ...copyInactivity[idx].time,
                [field]: value
            },
            wasModified
        };
        const copyErrorsInactivity = [...errors];
        copyErrorsInactivity[idx] = {
            ...errors[idx],
            time: {
                ...errors[idx].time,
                [field]: false,
                areInvalidTimes: verifyAreInvalidTimes(idx, field, value)
            }
        };
        return {
            values: copyInactivity,
            errors: copyErrorsInactivity
        };
    }
    const changeTime = (idx, field, value, wasModified) => {
        const {
            values, errors
        } = getNewInactivityTime(idx, field, value, wasModified)
        changeInactivity(values, errors);
    }
    const changeDate = (idx, value) => {
        const copyInactivity = [...inactivity];        
        copyInactivity[idx] = {
            ...copyInactivity[idx],
            date: value,
            wasModified: true
        };
        const copyErrorsInactivity = [...errors];
        copyErrorsInactivity[idx] = {
            ...errors[idx],
            date: false
        };
        changeInactivity(copyInactivity, copyErrorsInactivity);
    }
    const confirmInactivityDeleting = () => {
        deleteInactivityItem();
        setShowDialogDeleteInactivity({
            success: true,
            question: false
        });
    }
    const deleteInactivityItem = () => {
        const predicateToDeleteItem = (_, currentIdx) => {
            return currentIdxInactivityItemToDelete !== currentIdx;
        };
        const inactivityFiltered = inactivity.filter(predicateToDeleteItem);
        const inactivityErrorsFiltered = errors.filter(predicateToDeleteItem);
        changeInactivity([...inactivityFiltered], [...inactivityErrorsFiltered]);
        setPrevInactivity({
            values: [...inactivityFiltered],
            errors: [...inactivityErrorsFiltered]
        });
    }
    const saveChanges = idx => {
        const copyInactivity = [...inactivity];        
        copyInactivity[idx] = {
            ...copyInactivity[idx],
            wasModified: false
        };
        const copyErrorsInactivity = [...errors];
        copyErrorsInactivity[idx] = {
            ...errors[idx],
            wasModified: false
        };
        // Ordenando en función de la fecha y la hora
        copyInactivity.sort((a, b) => {
            if (a.date > b.date) return 1;
            if (a.date < b.date) return -1;
            return a.time.end > b.time.start ? 1 : -1;
        });
        // Cambiando inactividad
        changeInactivity(copyInactivity, copyErrorsInactivity);
        setPrevInactivity({
            values: [...copyInactivity],
            errors: [...copyErrorsInactivity]
        });
        toggleShowDialogSaveInactivity();
    }
    //#endregion
    return (
        <>
        <DialogAlert 
            show={show}
            close={() => closeDialog()}>
            <CloseButton onClick={() => closeDialog()}/>
            <Container>
                <TitleSection 
                    textAlign="center" 
                    fontWeight="900">Horas de inactividad</TitleSection>
                {inactivity.length > 0 &&
                <ListTime className="custom-scrollbar primary">
                    {inactivity.map((data, idx) => {
                        return (
                            <ListTimeItem
                                key={idx} 
                                idx={idx}
                                date={date} data={data}
                                errors={errors}
                                prevInactivity={prevInactivity}
                                inactivity={inactivity}
                                customTimeProps={{
                                    ratioMinutesTime, 
                                    intervalTimePicker
                                }}
                                customDateProps={{
                                    availableDay
                                }}
                                actions={{
                                    changeDate,
                                    changeTime,
                                    saveChanges,
                                    openDialogDeleteInactivityQuestion,
                                    changeInactivity
                                }}/>
                        );
                    })}
                </ListTime>}
                <ButtonLink onClick={addInactivityTime}>
                    Añadir más horas de inactividad
                </ButtonLink>
            </Container>
        </DialogAlert>
        <DialogAlertSuccessNotify
            show={showDialogSaveInactivity}
            toggleShow={toggleShowDialogSaveInactivity}
            title="Hemos guardado tus horas de inactividad"
            description="Podrás visualizarlo en la pantalla de edición."
            buttons={
                <CustomButton
                    variant="quaternary"
                    text="Volver a edición"
                    onClick={() => toggleShowDialogSaveInactivity(false)}
            />}/>
        <DialogAlertAction
            show={showDialogDeleteInactivity.question}
            toggleShow={() => toggleShowDialogDeleteInactivity("question")}
            title="¿Deseas eliminar la hora de inactividad?"
            content="Recuerda que esta información no se guardará y tendrás que empezar de nuevo.">
            <CustomButton
                variant="quintinary"
                text="Sí, eliminar"
                onClick={confirmInactivityDeleting}/>
            <CustomButton
                variant="quaternary"
                text="No, continuar"
                onClick={closeDialogDeleteInactivityQuestion}/>
        </DialogAlertAction>
        <DialogAlertSuccessNotify
            show={showDialogDeleteInactivity.success}
            toggleShow={() => toggleShowDialogDeleteInactivity("success")}
            title="Hora de inactividad eliminada exitosamente"
            description="Podrás visualizarlo en la pantalla de edición."
            buttons={
                <CustomButton
                    variant="quaternary"
                    text="Volver a edición"
                    onClick={() => toggleShowDialogDeleteInactivity("success", false)}/>
            }/>
        <DialogAlertAction
            show={showDialogCancelInactivityUpdating}
            toggleShow={toggleShowDialogCancelInactivityUpdating}
            title="¿Deseas cancelar la edición de inactividad?"
            content="Recuerda que esta información ya no se podrá visualizar.">
            <CustomButton
                variant="quintinary"
                text="Sí, cancelar"
                onClick={() => closeDialog(true)}/>
            <CustomButton
                variant="quaternary"
                text="No, continuar"
                onClick={() => toggleShowDialogCancelInactivityUpdating(false)}/>
        </DialogAlertAction>
        </>
    );
}

export default InactivityDialog;